import VideoPlayer from "components/ai/tools/VideoPlayer";
import AudioButton from "components/AudioButton";
import CommonHelper from "helpers/CommonHelper";
import styled from "styled-components";

import BlurOverlay from "../BlurOverlay";

const VideoMessage = (props) => {
  const {
    xUrl,
    videoUrl,
    hasSubscription,
    shouldBlur,
    setVideoModalState,
    onUnblurClick,
    url,
    scenario,
    game = {},
    dialog = {},
    videoWithSound = false,
  } = props;

  return (
    <>
      <PicturePlaceholder>
        {hasSubscription || !shouldBlur ? (
          <VideoWrapper>
            <VideoPlayer
              size="100%"
              imageUrl={xUrl}
              videoUrl={videoUrl}
              setVideoModalState={setVideoModalState}
              videoWithSound={videoWithSound}
            />
            {videoWithSound && (
              <AudioButtonContainer>
                <AudioButton analyticData={{
                  config_name: game?.name || game?.publicName || '',
                  scenario_name: game?.alias || '',
                  dialogId: dialog?.id
                }} />
              </AudioButtonContainer>
            )}
          </VideoWrapper>
        ) : (
          <>
            <PictureInnerPlaceholder src={CommonHelper.getFilesCdnUrl(xUrl)} />
            <BlurOverlay url={url} onUnblurClick={onUnblurClick} scenario={scenario} game={game} dialog={dialog} />
          </>
        )}
      </PicturePlaceholder>
    </>
  );
};

export default VideoMessage;


const PicturePlaceholder = styled.div`
  position: relative;
  box-sizing: border-box;
  border-radius: 20px;
  width: calc(min(75vh, 75vw, 320px));
  height: calc(min(75vh, 75vw, 320px));
  margin: 0 auto;
  display: flex;
  align-items: center; 
  justify-content: center;
`;

const VideoWrapper = styled.div`
  width: calc(min(75vh, 75vw, 320px));
  height: calc(min(75vh, 75vw, 320px));
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
`;

const AudioButtonContainer = styled.div`
  padding-top: 12px;
  margin-bottom: -12px;
  align-self: flex-start;
  padding-left: 6px;
`;

const PictureInnerPlaceholder = styled.div`
  border-radius: 20px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-image: url(${props => props.src});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: rgb(19, 19, 19);
`;
